import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl, teamNameLabel, teamHasLink } from '../../common/rcs_gaz_mc_core_FE';
import { BasketMatchRowWrapper } from './styles';
import TeamLabel from '../TeamLabel';
import IconFont from '../shared/IconFont';
import ConfigManager from '../../common/configManager/configManager';
import * as status from '../../constants/';
import Label from '../shared/Label';
import BasketTiming from '../TimeResults/BasketTiming';

const BasketMatchRow = ({
  matchRow, isMobile, sportId, dictionary, competitionId,
}) => {
  const basketTeamsUrl = ConfigManager.getBasketTeams('min');
  const isHomeWinner = () => (Number(matchRow.getIn(['teamHome', 'scores', 'total'])))
    > (Number(matchRow.getIn(['teamAway', 'scores', 'total']))) && matchRow.get('status') !== status.PLAYING;
  const isAwayWinner = () => (Number(matchRow.getIn(['teamHome', 'scores', 'total'])))
    < (Number(matchRow.getIn(['teamAway', 'scores', 'total']))) && matchRow.get('status') !== status.PLAYING;
  const isLive = () => (matchRow.get('status') === status.PLAYING);

  const parseImage = team => (teamHasLink(team.get('name')) ? `${basketTeamsUrl}${team.get('teamId')}.png` : false);

  const parseTeamName = (team) => {
    // const teamName = team.get('italianName') || team.get('name');
    const teamName = team.get('name');
    return teamNameLabel(teamName);
  };

  const classLink = () => {
    let returnedClass = '';
    if (!teamHasLink(matchRow.getIn(['teamHome', 'name'])) || !teamHasLink(matchRow.getIn(['teamAway', 'name'])) || String(competitionId) === '2') {
      returnedClass = 'no-event';
    }
    return returnedClass;
  };
  return (
    <BasketMatchRowWrapper
      href={prettyMatchUrl(matchRow.getIn(['teamHome', 'name']), matchRow.getIn(['teamAway', 'name']), matchRow.get('matchId'), sportId, competitionId, process.env.REACT_APP_SITE)}
      className={classLink()}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          md={0.6}
          sm={0.6}
          xs={0.6}
          style={{
            top: isMobile ? '-15px' : '',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
          }}
        />
        {isMobile &&
          <Col sm={6.5} xs={6.5} style={{ paddingRight: 0, paddingLeft: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamHome'))}
              color="black"
              image={parseImage(matchRow.get('teamHome'))}
              marginLeft={0.4}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
            <TeamLabel
              label={parseTeamName(matchRow.get('teamAway'))}
              color="black"
              image={parseImage(matchRow.get('teamAway'))}
              marginLeft={0.4}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3.5} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamHome'))}
              color="black"
              image={parseImage(matchRow.get('teamHome'))}
              marginLeft={0.5}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3.5} style={{ paddingLeft: '5px', paddingRight: 0 }}>
            <TeamLabel
              label={parseTeamName(matchRow.get('teamAway'))}
              color="black"
              image={parseImage(matchRow.get('teamAway'))}
              marginLeft={0.5}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
            />
          </Col>
        }
        <Col
          lg={1.4}
          md={2}
          sm={2}
          xs={2}
          style={{
            paddingLeft: 0,
            paddingRight: isMobile ? '0px' : '15px',
          }}
        >
          <BasketTiming
            status={matchRow.get('status')}
            isMobile={isMobile}
            timing={matchRow.get('timing')}
            date={matchRow.get('utcDate')}
            isLive={isLive()}
            dictionary={dictionary}
            competitionId={competitionId}
            isTimeKnown={matchRow.get('timeUnknown').toString() === 'no'}
          />
        </Col>
        <Col
          lg={2.2}
          md={1.8}
          sm={1.8}
          xs={1.8}
          style={{
            paddingRight: 0,
            paddingLeft: isMobile ? '0px' : '5px',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-evenly',
          }}
        >
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamHome', 'scores', 'total'])) ?
              matchRow.getIn(['teamHome', 'scores', 'total']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isHomeWinner()}
          />
          <Label
            label={(matchRow.get('status') !== status.FIXTURE && matchRow.getIn(['teamAway', 'scores', 'total'])) ?
              matchRow.getIn(['teamAway', 'scores', 'total']) : '-'}
            color={isLive() ? 'liveColor' : 'black'}
            margin={isMobile ? '0.8em' : '0.6em'}
            size={isMobile ? 0.85 : 1}
            lineHeight={1}
            isTitleNarrowMedium={isAwayWinner()}
          />
        </Col>
        <Col
          lg={0.75}
          md={1}
          sm={1}
          xs={1}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'row',
            paddingRight: isMobile ? '0px' : '10px',
            paddingLeft: isMobile ? '0' : '15px',
            opacity: competitionId === 2 ? '0' : '1',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
        </Col>
      </Row>
    </BasketMatchRowWrapper>
  );
};

BasketMatchRow.propTypes = {
  matchRow: PropTypes.any,
  isMobile: PropTypes.any,
  sportId: PropTypes.any,
  dictionary: PropTypes.any,
  competitionId: PropTypes.any,
};

export default BasketMatchRow;



// WEBPACK FOOTER //
// ./src/components/BasketMatchRow/index.js